import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert, InputAdornment, IconButton, Divider } from '@mui/material';
import RadarIcon from '@mui/icons-material/Radar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

const LoginPage = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [showPass, setShowPass] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(form.email, form.password);
            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao realizar login');
        } finally { setLoading(false); }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', bgcolor: '#f4f6f9' }}>
            {/* Left panel */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, flex: 1, bgcolor: '#074960', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', p: 6, gap: 3 }}>
                <RadarIcon sx={{ color: '#fff', fontSize: 80 }} />
                <Typography variant="h3" color="white" fontWeight={700} align="center">Compras Radar</Typography>
                <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.8)' }} align="center">
                    Pesquisa de preços para compras públicas conforme Lei 14.133/2021
                </Typography>
                <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 380 }}>
                    {['Integração com PNCP e Compras.gov.br', 'Cálculo automático de preço de referência', 'Relatórios em PDF para auditoria'].map(text => (
                        <Box key={text} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#fff' }} />
                            <Typography color="white" variant="body2">{text}</Typography>
                        </Box>
                    ))}
                </Box>
            </Box>

            {/* Right panel */}
            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', p: 4 }}>
                <Card sx={{ width: '100%', maxWidth: 420, p: 2 }}>
                    <CardContent>
                        <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', gap: 1, mb: 2 }}>
                            <RadarIcon color="primary" />
                            <Typography variant="h6" color="primary" fontWeight={700}>Compras Radar</Typography>
                        </Box>
                        <Typography variant="h5" fontWeight={700} mb={0.5}>Bem-vindo de volta</Typography>
                        <Typography variant="body2" color="text.secondary" mb={3}>Entre com suas credenciais para continuar</Typography>

                        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <TextField label="E-mail" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} fullWidth required />
                            <TextField
                                label="Senha" type={showPass ? 'text' : 'password'} value={form.password}
                                onChange={e => setForm(f => ({ ...f, password: e.target.value }))} fullWidth required
                                InputProps={{ endAdornment: <InputAdornment position="end"><IconButton onClick={() => setShowPass(s => !s)}>{showPass ? <VisibilityOffIcon /> : <VisibilityIcon />}</IconButton></InputAdornment> }}
                            />
                            <Button type="submit" variant="contained" fullWidth size="large" disabled={loading}>
                                {loading ? 'Entrando...' : 'Entrar'}
                            </Button>
                        </Box>

                        <Divider sx={{ my: 2 }} />
                        <Typography variant="body2" color="text.secondary" align="center">
                            Não tem conta?{' '}
                            <Typography component={Link} to="/cadastro" variant="body2" color="primary" sx={{ textDecoration: 'none', fontWeight: 600 }}>
                                Cadastre sua organização
                            </Typography>
                        </Typography>
                        {/*<Typography variant="caption" color="text.secondary" align="center" display="block" mt={2}>
                            Acesso demo: admin@demo.comprasradar.com.br / Admin123!
                        </Typography>*/}
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default LoginPage;
